export function DemoBrowser({ url, children, accent }) {
  return (
    <div className="demo-full__browser" style={accent ? { "--accent": accent } : undefined}>
      <div className="demo-full__browser-bar">
        <span className="demo-full__browser-dot demo-full__browser-dot--r" />
        <span className="demo-full__browser-dot demo-full__browser-dot--y" />
        <span className="demo-full__browser-dot demo-full__browser-dot--g" />
        <span className="demo-full__browser-url">{url}</span>
      </div>
      {children}
    </div>
  );
}

export function DemoMiniCorpSite({ brand, accent, tagline }) {
  return (
    <div className="demo-mini-site" style={{ "--accent": accent }}>
      <div className="demo-mini-site__nav">
        <strong>{brand}</strong>
        <div>
          <span>서비스</span>
          <span>실적</span>
          <span>문의</span>
        </div>
      </div>
      <div className="demo-mini-site__hero">
        <h3>{tagline}</h3>
        <p>기업의 첫인상을 매출로 연결하는 반응형 홈페이지</p>
        <span className="demo-mini-site__cta">무료 상담</span>
      </div>
      <div className="demo-mini-site__cards">
        <div className="demo-mini-site__card" />
        <div className="demo-mini-site__card" />
        <div className="demo-mini-site__card" />
      </div>
    </div>
  );
}

export function DemoFullFooter({ brand, desc, columns, copy }) {
  return (
    <footer className="demo-full__footer">
      <div className="demo-full__footer-grid">
        <div className="demo-full__footer-brand">
          <strong>{brand}</strong>
          <p>{desc}</p>
        </div>
        {columns.map((col) => (
          <div key={col.title} className="demo-full__footer-col">
            <strong>{col.title}</strong>
            {col.links.map((link) => (
              <span key={link}>{link}</span>
            ))}
          </div>
        ))}
      </div>
      <div className="demo-full__footer-copy">{copy}</div>
    </footer>
  );
}

export function DemoContactBlock({ title, sub, fields, btnLabel }) {
  return (
    <div className="demo-full__contact">
      <div>
        <h2 style={{ margin: "0 0 0.5rem", fontSize: "1.5rem", fontWeight: 800 }}>{title}</h2>
        <p style={{ margin: 0, fontSize: "0.88rem", lineHeight: 1.7, color: "var(--muted)" }}>{sub}</p>
        <div className="demo-full__trust" style={{ marginTop: "1.5rem", gap: "1.5rem" }}>
          <div><strong>02-1234-5678</strong>전화 상담</div>
          <div><strong>평일 09-18시</strong>운영 시간</div>
        </div>
      </div>
      <div className="demo-full__form">
        {fields.map((f) => (
          <div key={f} className={`demo-full__field${f.includes("문의") ? " demo-full__field--area" : ""}`}>
            {f}
          </div>
        ))}
        <span className="demo-full__btn demo-full__btn--primary" style={{ textAlign: "center" }}>{btnLabel}</span>
      </div>
    </div>
  );
}
